import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import * as common from '../../../../common'
import type { Entity } from '../../types'

export const DOC = gql`
  ${common.gql.faFunctions.fragments.categorizationIds.DOC}
  fragment FragmentRateReportLabel on RateReportLabel {
    code
    hint
    id
    isActive
    name
    position
    faFunctionCategorization {
      ...FragmentFaFunctionCategorizationIds
    }
  }
  query ReportLabels(
    $scenarioId: ID!
    $appId: ID!
    $zoneId: ID!
    $tenantId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              rate {
                reportLabels {
                  ...FragmentRateReportLabel
                }
              }
            }
          }
        }
      }
    }
  }
`

const REPORT_LABEL_TRANSFORMER = graphql.transformers.OUT.object<
  graphql.schema.FragmentRateReportLabelFragment,
  Entity['label']
>({
  code: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  faFunctionCategorization:
    common.gql.faFunctions.fragments.categorizationIds.TRANSFORMER,
  hint: transformers.PASS_THROUGH,
  id: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    ents.extra.rate.Report.Id.assertIsId,
    { warnOnly: true },
  ),
  isActive: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  name: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
  position: graphql.transformers.OUT.validate(
    transformers.PASS_THROUGH,
    TypeAsserter.assertIsNotNullish,
    { warnOnly: true },
  ),
})

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ReportLabelsQuery,
    Entity[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'rate',
              graphql.transformers.OUT.select(
                'reportLabels',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.nest(
                    'label',
                    graphql.transformers.OUT.validate(
                      REPORT_LABEL_TRANSFORMER,
                      TypeAsserter.assertIsNotNullish,
                      { warnOnly: true },
                    ),
                  ),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ReportLabelsQuery,
  Entity[],
  graphql.schema.ReportLabelsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
